export default "__VITE_ASSET__U3oNTlX4__"